import { Skeleton } from "../../../components/common";

export function SurveyStatsSkeleton({ cards = 4 }: { cards?: number }) {
  return (
    <div
      className="mb-4 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4"
      data-testid="survey-stats-skeleton"
    >
      {Array.from({ length: cards }, (_, index) => (
        <div
          key={index}
          className="relative rounded-lg border border-gray-200 bg-white p-4 dark:border-[#394150] dark:bg-[#212936]"
        >
          <div className="flex items-start justify-between">
            <div className="flex-1 space-y-2">
              <Skeleton className="h-7 w-16" />
              <Skeleton className="h-4 w-3/4" />
            </div>
            <Skeleton className="ml-4 h-8 w-8 rounded-lg" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function SurveyListTableSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div data-testid="survey-list-table-skeleton">
      <div className="mb-3 flex items-center gap-3">
        <Skeleton className="h-9 w-48" />
        <Skeleton className="h-9 w-32" />
        <Skeleton className="ml-auto h-9 w-24" />
      </div>
      <div className="space-y-2 rounded-lg border border-gray-200 bg-white p-4 dark:border-[#394150] dark:bg-[#212936]">
        {Array.from({ length: rows }, (_, index) => (
          <Skeleton
            key={index}
            className="h-10 w-full"
            data-testid="survey-list-table-skeleton-row"
          />
        ))}
      </div>
      <div className="mt-4 flex items-center justify-center gap-2">
        <Skeleton className="h-8 w-20" />
        <Skeleton className="h-8 w-8" />
        <Skeleton className="h-8 w-8" />
        <Skeleton className="h-8 w-8" />
        <Skeleton className="h-8 w-20" />
      </div>
    </div>
  );
}

export function SurveyDetailSkeleton({ questions = 2 }: { questions?: number }) {
  return (
    <div
      className="space-y-6 p-6"
      data-testid="survey-detail-skeleton"
    >
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <Skeleton className="h-7 w-64" />
          <Skeleton className="h-4 w-96" />
        </div>
        <Skeleton className="h-9 w-24" />
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {Array.from({ length: 3 }, (_, index) => (
          <div
            key={index}
            className="flex items-center gap-3 rounded-lg border border-gray-200 bg-white p-3 dark:border-gray-700 dark:bg-gray-900"
          >
            <Skeleton className="h-8 w-8 rounded-lg" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-1/2" />
              <Skeleton className="h-4 w-3/4" />
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <Skeleton className="h-9 w-24" />
        <Skeleton className="h-9 w-32" />
        <Skeleton className="h-9 w-28" />
      </div>
      {Array.from({ length: questions }, (_, index) => (
        <div
          key={index}
          className="space-y-3 rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-900"
        >
          <Skeleton className="h-5 w-2/3" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
        </div>
      ))}
    </div>
  );
}

export function SurveyResponsesSkeleton({ questions = 2 }: { questions?: number }) {
  return (
    <div
      className="space-y-8 p-6"
      data-testid="survey-responses-skeleton"
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {Array.from({ length: 3 }, (_, index) => (
          <div
            key={index}
            className="relative space-y-2 rounded-lg border bg-white p-6 shadow-sm dark:border-gray-600 dark:bg-gray-800"
          >
            <Skeleton className="absolute right-4 top-4 h-8 w-8 rounded-lg" />
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="h-8 w-1/3" />
          </div>
        ))}
      </div>
      {Array.from({ length: questions }, (_, index) => (
        <div
          key={index}
          className="space-y-3 rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-600 dark:bg-gray-800"
        >
          <Skeleton className="h-5 w-1/2" />
          <Skeleton className="h-48 w-full rounded-md" />
        </div>
      ))}
    </div>
  );
}
